import { createTheme, ThemeOptions } from '@mui/material/styles';

import 'theme/types/palette';
import 'theme/types/typography';
import breadcrumb from 'theme/breadcrumb';
import button from 'theme/button';
import colors from 'theme/colors';
import outlinedInput from 'theme/outlinedInput';
import tableBody from 'theme/tableBody';
import tableHead from 'theme/tableHead';
import typography from 'theme/typography';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      xxs: 361, // 0–360px: use theme.breakpoints.down('xxs'); 361px+: use theme.breakpoints.up('xxs')
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    primary: {
      main: colors.primary.main,
      light: colors.primary.light,
      dark: colors.primary.dark,
      contrastText: colors.primary.contrastText,
    },
    secondary: {
      main: colors.secondary.main,
      light: colors.secondary.light,
      dark: colors.secondary.dark,
      contrastText: colors.secondary.contrastText,
    },
    error: {
      main: colors.error.main,
      light: colors.error.light,
      dark: colors.error.dark,
      contrastText: colors.error.contrastText,
    },
    success: {
      main: colors.success.main,
      light: colors.success.light,
      dark: colors.success.dark,
      contrastText: colors.success.contrastText,
    },
    text: {
      primary: colors.text.primary,
      secondary: colors.text.secondary,
      disabled: colors.text.disabled,
      tertiary: colors.text.tertiary,
    },
    background: {
      default: colors.background.main,
      paper: colors.background.light,
    },
  },
  typography: typography as unknown as ThemeOptions['typography'],
  components: {
    MuiButton: button,
    MuiBreadcrumbs: breadcrumb,
    MuiOutlinedInput: outlinedInput,
    MuiTableHead: tableHead,
    MuiTableBody: tableBody,
  },
} as ThemeOptions);

export default theme;
